"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./AlbertaCta.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-454":{"id":"e-454","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-455"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f492e07d-6076-8477-6e91-4e973cecb3f8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f492e07d-6076-8477-6e91-4e973cecb3f8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319983382},"e-456":{"id":"e-456","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-457"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f492e07d-6076-8477-6e91-4e973cecb3fa","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f492e07d-6076-8477-6e91-4e973cecb3fa","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319992612},"e-482":{"id":"e-482","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-23","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-483"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1716505315197}},"actionLists":{"a-23":{"id":"a-23","title":"skeleton-loader","actionItemGroups":[{"actionItems":[{"id":"a-23-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":1000,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-23-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":-100,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-23-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-23-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":800,"target":{"selector":".skeleton-loader-animation","selectorGuids":["8f7e00cc-0b33-d9e9-3cb0-9ba1d827d7cf"]},"xValue":250,"xUnit":"%","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1716505320174},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function AlbertaCta({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "alberta_section-cta")}
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-bottom-xxlarge")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "alberta_cta-card",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "alberta_cta-copy-wrap",
                  "max-width-medium"
                )}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_cta-heading",
                    "heading-style-h4"
                  )}
                  data-w-id="f492e07d-6076-8477-6e91-4e973cecb3f8"
                  tag="div"
                >
                  {"👋 Alberta Landlords - Try our Growth Plan for free"}
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(_styles, "albberta_cta-description")}
                  data-w-id="f492e07d-6076-8477-6e91-4e973cecb3fa"
                  tag="div"
                >
                  {"We invite you to celebrate our launch to Alberta with a "}
                  <_Builtin.Strong>
                    {"free 1-month trial to our Growth Plan"}
                  </_Builtin.Strong>
                  {"*"}
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_cta-form-card")}
                tag="div"
                id="alberta_stats-cta-form"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "skeleton-loader")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "skeleton-loader-animation")}
                    tag="div"
                  />
                </_Builtin.Block>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_cta-ribbon-wrap")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(_styles, "alberta_cta-ribbon")}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "alberta_cta-ribbon-text")}
                    tag="div"
                  >
                    {"exclusive offer"}
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "disclaimer-container",
                "padding-xsmall",
                "align-center",
                "max-width-large"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "text-size-tiny",
                  "text-color-tertiary",
                  "disclaimer"
                )}
                tag="div"
              >
                {
                  "* This promotion is only valid for new users in Alberta. By signing up, you will receive a free 1-month trial of liv.rent's Growth Plan. After the first month, regular charges will apply. You can cancel at any time. "
                }
                <_Builtin.Link
                  className={_utils.cx(_styles, "disclaimer-link")}
                  button={false}
                  block=""
                  options={{
                    href: "/terms",
                    target: "_blank",
                  }}
                >
                  {"View terms & conditions"}
                </_Builtin.Link>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
